
import Vue from 'vue'
import _ from 'lodash'
import { DEFAULT_PAGE_SIZE } from '@/config/app'
import { i18n } from '@/i18n'


const getDefaultState = () => {
  return {
    paginationInfo: {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    },
    currentPage: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: null,
    order: null,
    filters: [],
    notificationsNumber: {},
    masterFilters: {
      cif: { label: 'cif', value: '' },
      name: { label: 'Razón social', value: '' },
      automatic_download: { label: 'Descarga automática', value: '' },
      send_alerts: { label: 'Enviar avisos', value: '' },
      estado: { label: i18n.t('companies.active'), value: '' },
      email: { label: i18n.t('configurations.email'), value: '' },
      fechaAltaDesde: { label: 'alta desde', value: '' },
      fechaAltaHasta: { label: 'alta hasta', value: '' }
    },
    notUseLikeTags: ['results', 'page', 'sort', 'order', 'status'],
    kendo: {
      columns: [
        { field: 'selected', width: '50px', minResizableWidth: 25, headerSelectionValue: false, locked: true, reorderable: false, groupable: false },
        { field: 'CIF', title: i18n.t('companies.cif'), columnMenu: 'myTemplate', width: '150px', minResizableWidth: 75, locked: false },
        { field: 'NombreCIF', title: i18n.t('companies.companyName'), columnMenu: 'myTemplate', width: '150px', minResizableWidth: 75, locked: false },
        { field: 'EmailAvisoNueva', title: i18n.t('companies.email_alerts'), columnMenu: 'myTemplate', width: '275px', minResizableWidth: 137, locked: false },
        { field: 'EmailDiasAviso', title: i18n.t('companies.email_ultima_llamada'), columnMenu: 'myTemplate', width: '375px', minResizableWidth: 187, locked: false },
        { field: 'EmailAvisoTramitacionUrgente', title: i18n.t('companies.email_tramitacion_urgente'), columnMenu: 'myTemplate', width: '375px', minResizableWidth: 187, locked: false },
        { field: 'EmailAvisoErrores', title: i18n.t('companies.email_neos_error'), columnMenu: 'myTemplate', width: '375px', minResizableWidth: 187, locked: false },
        { field: 'AgruparEmailsAvisos', title: i18n.t('configurations.mails_group_status'), columnMenu: 'myTemplate', width: '450px', minResizableWidth: 225, locked: false, cell: 'checkboxTemplate' },
        { field: 'EnviarAvisos', width: '150px', minResizableWidth: 75, title: i18n.t('companies.send_alerts'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
        { field: 'DiasAviso', width: '425px', minResizableWidth: 212, title: i18n.t('companies.download_alert_days_form'), columnMenu: 'myTemplate', locked: false },
        { field: 'DiasFinTramite', width: '400px', minResizableWidth: 200, title: i18n.t('companies.end_alert_days_label_form'), columnMenu: 'myTemplate', locked: false },
        { field: 'EmailAvisoDescargada', title: i18n.t('companies.email_downloads'), columnMenu: 'myTemplate', width: '300px', minResizableWidth: 150, locked: false },
        { field: 'DiasDescargaAutomatica', width: '425px', minResizableWidth: 212, title: i18n.t('companies.automatic_download_days_label'), hidden: true, columnMenu: 'myTemplate', locked: false },
        { field: 'EmailAvisoTramitada', title: i18n.t('companies.email_tramitada'), columnMenu: 'myTemplate', width: '300px', minResizableWidth: 150, locked: false },
        { field: 'FechaAlta', title: i18n.t('companies.created_at'), type: 'date', filter: 'date', format: '{0:dd-MM-yyyy HH:mm }', columnMenu: 'myTemplate', width: '150px', minResizableWidth: 75, locked: false },
        { field: 'DescargaAutomatica', width: '300px', minResizableWidth: 150, title: i18n.t('companies.automatic_download'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
        { field: 'CodigoExt', title: i18n.t('companies.codigoext'), hidden: true, columnMenu: 'myTemplate', width: '200px', minResizableWidth: 100, locked: false },
        { field: 'Activo', title: i18n.t('companies.active'), columnMenu: 'myTemplate', width: '100px', minResizableWidth: 50, locked: false, cell: 'checkboxTemplate' },
        {
          field: 'Agrupaciones',
          width: '440px',
          minResizableWidth: 220,
          title: i18n.t('app.grouping'),
          columnMenu: 'myTemplate',
          locked: false,
          cell: 'tagsTemplate',
          type: 'boolean',
          sortable: false,
          groupable: false
        },
        { field: 'EmailTecnico', title: i18n.t('companies.email_tech'), columnMenu: 'myTemplate', width: '350px', minResizableWidth: 175, locked: false },
        { field: 'IdCIFEmpresa', title: i18n.t('companies.idcif_empresa'), hidden: true, columnMenu: 'myTemplate', width: '150px', minResizableWidth: 75, locked: false },
        { field: 'IdEmpresa', title: i18n.t('companies.id_client'), hidden: true, columnMenu: 'myTemplate', width: '150px', minResizableWidth: 75, locked: false }
      ],
      skip: 0,
      take: 10,
      sortable: true,
      groupable: true,
      sort: [],
      group: [],
      filter: null,
      columnMenu: true,
      dataResult: null,
      navigate: false
    }
  }
}

const state = getDefaultState()

const getters = {
  getKendo: state => state.kendo,
  getPayloadCurrentPage: state => state.paginationInfo.currentPage,
  getPayloadPageSize: state => state.paginationInfo.pageSize,
  getPayloadTotal: state => state.paginationInfo.total,
  getPayLoadTotalPages: state => state.paginationInfo.totalPages,
  getMasterFilters: state => state.masterFilters,
  getCurrentPage: state => state.currentPage,
  getPageSize: state => state.pageSize,
  getNotificationsNumber: state => state.notificationsNumber,
  getPaginationInfo: state => {
    state.paginationInfo.pageSize = state.pageSize
    return state.paginationInfo
  },
  getFilters: (state) => {
    state.filters.results = state.pageSize
    state.filters.page = state.currentPage
    if (state.order) {
      state.filters.order = state.order
    } else {
      delete (state.filters.order)
    }
    if (state.sort && state.filters.order) {
      state.filters.sort = state.sort
    } else {
      delete (state.filters.sort)
    }
    return state.filters
  },
  getTags: (state) => {
    const tags = []
    _.each(state.filters, (item, key) => {
      if (state.notUseLikeTags.indexOf(key) === -1) {
        tags.push([key, item.label, item.value])
      }
    })
    return tags
  },
  getAppliedFilters (state) {
    const data = {}
    const _temp = Object.entries(state.masterFilters)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
    })
    state.filters = data
    return data
  }
}

const mutations = {
  setKendoColumns (state, data) {
    data.unshift('selected')
    state.kendo.columns = state.kendo.columns.map(x => {
      if (data.includes(x.field)) {
        x.hidden = false
      } else {
        x.hidden = true
        data.push(x.field)
      }
      return x
    }).sort((a, b) => data.indexOf(a.field) - data.indexOf(b.field))
  },
  setKendo (state, kendo) {
    state.kendo = kendo
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  resetStateWithoutSort (state, data) {
    Object.assign(state, getDefaultState())
    // Object.assign(state, getDefaultState())
    state.kendo.sort = data.sort
    state.kendo.group = data.group
  },
  resetPaginationInfo (state, data) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.paginationInfo = {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    }
  },
  setPaginationInfo (state, data) {
    state.paginationInfo = data
  },
  setSort (state, fieldName) {
    state.sort = fieldName
  },
  setSortOrder (state, order) {
    switch (order) {
      case 'ascending':
        state.order = 'asc'
        break
      case 'descending':
        state.order = 'desc'
        break
      default:
        state.order = null
        state.sort = null
    }
  },
  setNotUseLikeTags (state, items = []) {
    state.notUseLikeTags = items
  },
  setMasterFilters (state, master) {
    const data = {}
    const _temp = Object.entries(master)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
    })
    state.masterFilters = data
    // console.log(data)
  },
  setNotificationsNumber (state, notificationsNumber) {
    state.notificationsNumber = notificationsNumber
  },
  resetNotificationsNumber () {
    state.notificationsNumber = {}
  },
  removeTag (state, tag) {
    const path = tag.split('.')
    if (path.length === 1) {
      state.masterFilters[path[0]] = ''
    }
    if (path.length === 2) {
      state.masterFilters[path[0]][path[1]] = ''
    }
  },
  resetMasterFilters (state) {
    state.masterFilters = {
      cif: { label: 'cif', value: '' },
      name: { label: 'Razón social', value: '' },
      automatic_download: { label: 'Descarga automática', value: '' },
      send_alerts: { label: 'Enviar avisos', value: '' },
      fechaAltaDesde: { label: 'alta desde', value: '' },
      estado: { label: i18n.t('companies.active'), value: '' },
      email: { label: i18n.t('configurations.email'), value: '' },
      fechaAltaHasta: { label: 'alta hasta', value: '' }
    }
  },
  setFilter (state, { key, value }) {
    Vue.set(state.filters, { key: value })
  },
  setFilters (state, thefilters) {
    Vue.set(state, 'filters', thefilters)
  },
  clearFilters (state) {
    Vue.set(state, 'filters', [])
  },
  clearPagination (state) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.currentPage = 1
  },
  setPageSize (state, size) {
    state.pageSize = size
  },
  setCurrentPage (state, pageNumner) {
    if (pageNumner > 0 && pageNumner <= state.paginationInfo.totalPages) {
      state.currentPage = pageNumner
      state.paginationInfo.currentPage = pageNumner
    }
  }
}

const actions = {
  resetCartState ({ commit }) {
    commit('resetState')
  },
  resetStateWithoutSort ({ commit, rootGetters }) {
    const data = {
      sort: rootGetters['groupcompaniesPersisted/getSort'],
      group: rootGetters['groupcompaniesPersisted/getGroup'],
    }
    commit('resetStateWithoutSort', data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
